import { createMuiTheme, Theme } from "@material-ui/core/styles";
import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";

export interface IDRaksTheme extends Theme {
  opacityMask4: string;
  opacityMask8: string;
  iconForeground: string;
  light: string;
  medium: string;
  disabled: string;
  high: string;
  scrollbarTrack: string;
  scrollbarThumb: string;

  messagePanelErrorText: string;
  messagePanelErrorBackground: string;
  messagePanelErrorIcon: string;
  messagePanelWarningText: string;
  messagePanelWarningBackground: string;
  messagePanelWarningIcon: string;
  messagePanelInfoText: string;
  messagePanelInfoBackground: string;
  messagePanelInfoIcon: string;
  messagePanelSuccessText: string;
  messagePanelSuccessBackground: string;
  messagePanelSuccessIcon: string;
}

function createLightTheme(options: ThemeOptions): IDRaksTheme {
  let theme: IDRaksTheme = createMuiTheme(options) as IDRaksTheme;
  theme.opacityMask4 = "rgba(0, 0, 0, 0.04)";
  theme.opacityMask8 = "rgba(0, 0, 0, 0.08)";
  theme.iconForeground = "#9b9b9b";
  theme.light = "rgba(255, 255, 255, 0.88)";
  theme.medium = "rgba(0, 0, 0, 0.6)";
  theme.disabled = "rgba(0, 0, 0, 0.38)";
  theme.high = "rgba(0, 0, 0, 0.87)";
  theme.scrollbarTrack = "#f1f1f1";
  theme.scrollbarThumb = "#c1c1c1";

  theme.messagePanelErrorText = "#611a15";
  theme.messagePanelErrorBackground = "#fdecea";
  theme.messagePanelErrorIcon = "#d32f2f";

  theme.messagePanelWarningText = "#663c00";
  theme.messagePanelWarningBackground = "#fff4e5";
  theme.messagePanelWarningIcon = "#ff9800";

  theme.messagePanelInfoText = "#ffffff";
  theme.messagePanelInfoBackground = "#74ABE2";
  theme.messagePanelInfoIcon = "#ffffff";

  theme.messagePanelSuccessText = "#1e4620";
  theme.messagePanelSuccessBackground = "#edf7ed";
  theme.messagePanelSuccessIcon = "#4caf50";

  return theme;
}

export const lightTheme = createLightTheme({
  palette: {
    type: "light",
    background: {
      default: "#e4e4e8",
      paper: "#fff"
    },

    primary: {
      main: "#242939",
      contrastText: "#fff"
    },

    secondary: {
      main: "#1565d8",
      contrastText: "#fff"
    },

    error: {
      main: "#d6405b",
      contrastText: "#fff"
    }
  },
  typography: {
    fontFamily: "Ubuntu"
  },

  overrides: {
    MuiDrawer: {
      paperAnchorRight: {
        "box-shadow": "none",
        "background-color": "transparent"
      }
    },
    MuiFormControlLabel: {
      label: {
        color: "rgba(0, 0, 0, 0.87)"
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "14px",
        fontFamily: "Ubuntu",
        fontWeight: 500,
        padding: "12px 16px",
        backgroundColor: "#5f5e5e",
        maxWidth: "none"
      }
    },
    MuiFormHelperText: {
      contained: { marginLeft: "0px", marginTop: "0px" },
      root: {
        "&$error": { marginTop: "-3px" }
      }
    }
  },
  props: {
    MuiTextField: {
      variant: "filled",
      color: "secondary"
    },
    MuiSelect: {
      color: "secondary"
    },
    MuiInputLabel: {
      color: "secondary"
    }
  }
});
